import { Injectable } from '@angular/core';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { AssetType } from '../../../models/assets-model';

export interface ICurrentAssetContext {
    assetOpenedFrom: assetsOpenedFromType;
    assetType: AssetType;
}
export type assetsOpenedFromType = 'assets' | 'scene-setup' | 'GENERATE-IMAGE_FROM_ASSETS';
@Injectable()
export class GenerateAssetTypeManagerService {
    private _assetOpenedFrom: assetsOpenedFromType = null;
    private _assetType: AssetType = null;

    private _currentAssetContextSubject = new BehaviorSubject<ICurrentAssetContext>(null);
    public currentAssetContext$ = this._currentAssetContextSubject.asObservable();

    private _isInGenerateComponentSubject = new BehaviorSubject<boolean>(false);
    public isInGenerateComponentSubject$ = this._isInGenerateComponentSubject.asObservable();

    public generateAssetContext$ = combineLatest([this.currentAssetContext$, this.isInGenerateComponentSubject$]);

    constructor() {}
    setCurrentAssetOpenedFrom(assetOpenedFrom: assetsOpenedFromType) {
        this._assetOpenedFrom = assetOpenedFrom;
        this.setCurrentAssetContext();
    }
    setCurrentAssetType(assetType: AssetType) {
        this._assetType = assetType;
        this.setCurrentAssetContext();
    }

    setCurrentAssetContext() {
        this._currentAssetContextSubject.next({
            assetOpenedFrom: this._assetOpenedFrom ?? null,
            assetType: this._assetType ?? null,
        });
    }

    setIsInGenerateComponent(isInGenerate: boolean) {
        this._isInGenerateComponentSubject.next(isInGenerate);
    }
}
